<template>
  <div class="page_404">
    <h1 class="home__title">404 ошибка</h1>
    <div class="message _error">Запрошенная вами страница не найдена.</div>
  </div>
</template>
<script>
export default {
  metaInfo: {
    title: 'Ошибка 404'
  }
};
</script>
